var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "800"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-arrow-up-thin")]), _vm._v(" Enviar Ata " + _vm._s(_vm.content.id) + " ")], 1)]), _c('div', {
    staticClass: "container dialog pa-2"
  }, [_vm.visible ? _c('v-form', {
    ref: "form"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "alert-message d-flex align-center mt-4"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Atenção!"), _c('br'), _vm._v(" Faça o upload de pelo menos um arquivo nos formatos .pdf, .png ou .jpeg, com tamanho máximo de 5MB. ")])], 1)]), _c('v-row', {
    staticClass: "text-center mb-5"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', [_vm._v("Ata de Formação")]), _c('v-btn', {
    staticClass: "text-none",
    attrs: {
      "color": "primary",
      "rounded": "",
      "depressed": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.uploader.click();
      }
    }
  }, [_c('div', [_c('v-icon', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(" mdi-cloud-upload ")])], 1)]), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": ".jpeg, .jpg, .png, .pdf"
    },
    on: {
      "click": function ($event) {
        _vm.$refs.uploader.value = null;
      },
      "change": _vm.adicionarArquivo
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', [_vm._v("Baixar Modelo")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        return _vm.baixarModelo();
      }
    }
  }, [_c('v-icon', [_vm._v(" mdi-cloud-download ")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("Quantidade de Participantes Presentes:")]), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "type": "number",
      "rules": [_vm.$required, function (v) {
        return _vm.$minValue(v, 1);
      }, function (v) {
        return _vm.$maxValue(v, 1000);
      }]
    },
    model: {
      value: _vm.content.quantidadeDeParticipantes,
      callback: function ($$v) {
        _vm.$set(_vm.content, "quantidadeDeParticipantes", $$v);
      },
      expression: "content.quantidadeDeParticipantes"
    }
  })], 1)], 1) : _vm._e(), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.content.anexos,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.name) + " ")];
      }
    }, {
      key: `item.tipo`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" ." + _vm._s(_vm.getFileType(item.name)) + " ")];
      }
    }, {
      key: `item.tamanho`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.getFileSize(item.size)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "small": "",
            "text": "Realizar Download",
            "icon": "mdi-arrow-down"
          },
          on: {
            "click": function ($event) {
              return _vm.baixarArquivo(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "small": "",
            "text": "Deletar Arquivo",
            "icon": "mdi-trash-can-outline"
          },
          on: {
            "click": function ($event) {
              return _vm.removerArquivo(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Salvar"
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }